import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from './metrika';

/**
 * Отправляет хит в Яндекс.Метрику при каждой смене роута.
 *
 * Подводный камень SPA: автотрекер Метрики ловит только первую навигацию
 * (загрузку документа). Последующие клиентские смены роута требуют явного
 * `ym(id, 'hit', url)` — это и делает хук. Подключать один раз внутри
 * роутера, чтобы был доступен `useLocation`.
 */
export function usePageviewTracking(): void {
  const location = useLocation();

  useEffect(() => {
    const url = location.pathname + location.search;
    trackPageView(url, document.title);
  }, [location.pathname, location.search]);
}
